export {
  SwissCantonSchema,
  type SwissCanton,
  SwissQualificationSchema,
  type SwissQualification,
  ReferralSourceSchema,
  type ReferralSource,
  SpitexSupplyFieldsSchema,
  type SpitexSupplyFields,
  SpitexDemandFieldsSchema,
  type SpitexDemandFields,
  spitexSupplyConfig,
  spitexDemandConfig,
} from './config';

export {
  qualificationLabels,
  serviceInterestLabels,
  medizinischeAusbildungLabels,
  careTypeLabels,
  cantonLabels,
  availabilityLabels,
  referralSourceLabels,
  specializationLabels,
} from './labels';

export {
  spitexSupplyConversationConfig,
  spitexDemandConversationConfig,
} from './conversation-config';

export { spitexSupplyMedia, spitexDemandMedia } from './media';

export {
  estimateCaregiverWage,
  EstimateCaregiverWageInputSchema,
  WageEstimateError,
  PLACEHOLDER_HOURLY_RATE_CHF,
  PLACEHOLDER_SUPPORTED_CANTONS,
  PLACEHOLDER_BILLABLE_TASKS,
  BILLABLE_TASK_LABELS_DE,
  MAX_HOURS_PER_DAY,
  WAGE_ESTIMATE_DISCLAIMER_DE,
  type EstimateCaregiverWageInput,
  type RawEstimateCaregiverWageInput,
  type WageEstimate,
  type EligibleWageEstimate,
  type IneligibleWageEstimate,
  type WageEstimateIneligibilityReason,
} from './wage-estimate';

export {
  spitexAngehoerigenpflegeWageQuizFlow,
  type WageQuizFlow,
  type WageQuizStep,
  type QuizStepOption,
  type QuizStepRender,
  type WageQuizDisqualifier,
} from './wage-quiz-flow';
